import getFromToken from './getFromToken';
import claim from './claim';

export default host => ({
  getFromToken: getFromToken(host),
  claim: claim(host),
})
